"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegionValueProvider = useRegionValueProvider;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const classifiers_1 = require("../../classifiers");
function useRegionValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (0, classifiers_1.buildPublicDataValueProvider)({
        label: t('defaultClassifiers.region'),
        ...params,
        classifierName: 'region',
    });
}
